export const CHARACTER_LIMIT = {
  ACTION_SUMMARY: 200,
  BREAK_THE_GLASS_NOTE: 600,
  CONSULT_NOTES: 575,
  CUSTOM_NORMAL: 300,
  FINDING_SUMMARY: 90,
  KEY_IMAGE_LABEL: 200,
  QUALITY_REVIEW_NOTES: 200,
  TECHNIQUE: 600,
} as const;
